import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';

export type RemoveClientReportFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: RemoveClientReportFormProps) => {
  const [
    fnRemoveClientReportForm,
    { loading }
  ] = ds.useRemoveClientReport();

  const handleSubmit = async (id: string) => {

    await fnRemoveClientReportForm(id);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(props.id);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <></>
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
